import Axios from "axios";
import Cookies from "js-cookie";

const client = Axios.create();

client.interceptors.request.use(function (config) {
  if (config.url?.includes('login')) return config;

  const token = Cookies.get(window.__env.AUTH_TOKEN_NAME || "alida-token");

  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;
}, function (err) {
  return Promise.reject(err);
});

client.interceptors.response.use(
  (res) => res,
  function (err) {
    const res = err.response;
    if (res && !res.config.url.includes('login') && !res.config.url.includes('token')) {
      if (res.status === 401) {
        Cookies.remove(window.__env.AUTH_TOKEN_NAME || "alida-token");
        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  });

export default client;